import type { RequestConfig } from '@customTypes/index';
import type { ArtistFullProfileInfoDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ShowFullArtistProfileRequest = {
  profileId: string;
};

export type FullArtistProfileParams =
  RequestConfig<ShowFullArtistProfileRequest>;

export const showFullArtistProfile = async ({
  params,
  config
}: FullArtistProfileParams) =>
  api.get<ArtistFullProfileInfoDto>(
    `/api/ArtistProfile/${params.profileId}/full-profile`,
    config
  );
